"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_access-permission.scss");

function AccessPermissions(_ref) {
  var onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      options = _ref.options;
  return _react["default"].createElement("div", {
    className: "share-modal-access-permission__container"
  }, _react["default"].createElement("span", {
    className: "share-modal-access-permission__container__header"
  }, "Access Permissions"), _react["default"].createElement(_uiKit.Icon, {
    name: "info",
    color: "michael",
    size: 15
  }), _react["default"].createElement("div", {
    className: "share-modal-access-permission__container__content"
  }, _react["default"].createElement("p", {
    className: "share-modal-access-permission__container__content__text"
  }, "Someone with this link"), _react["default"].createElement(_uiKit.Dropdown, {
    className: "share-modal-access-permission__container__drop-down",
    type: "BASIC",
    onChange: onChange,
    defaultValue: defaultValue,
    options: options
  })));
}

var _default = (0, _react.memo)(AccessPermissions);

exports["default"] = _default;